import type { ExternalTableSchema } from '@packages/table-builder';

export const tradePreClearanceTable: ExternalTableSchema = {
  metadata: {
    title: 'Trade Pre-Clearance',
    description: 'Manage your trade pre-clearance list.',
    entity: 'TradePreClearance',
  },

  dataSource: {
    endpoint: '/api/customer/api/app/trade-pre-clearance/trade-pre-clearance-list',
    method: 'GET',
    rowIdField: 'participantId',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      Sorting: 'table.sorting',
      SkipCount: 'table.pageOffset',
      MaxResultCount: 'table.pageSize',
      DepartmentId: 'filters.departmentId',
      EmployeTypeId: 'filters.employeeTypeId',
      JobTitleId: 'filters.jobTitleId',
      TypeIds: 'filters.typeIds',
    },
    filters: [
      {
        name: 'departmentId',
        placeholder: 'Department',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/customer-department/customer-departments',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'employeeTypeId',
        placeholder: 'Employee Type',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/employee-type/employee-types',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'jobTitleId',
        placeholder: 'Job Title',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/customer-title/customer-titles',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'typeIds',
        placeholder: 'Type',
        type: 'select',
        multiple: true,
        options: [
          { label: 'Rule 144', value: '1' },
          { label: 'Section 16', value: '2' },
        ],
      },
    ],
  },

  columns: [
    {
      field: 'participantName',
      header: 'Participant Details',
      type: 'couple',
      sortable: true,
      width: 200,
      couple: { titleField: 'participantName', subtitleField: 'employeeId' },
    },
    { field: 'employeeType', header: 'Employee Type', sortable: true, width: 200 },
    { field: 'department', header: 'Department', sortable: true, width: 200 },
    { field: 'jobTitle', header: 'Job Title', sortable: true, width: 200 },

    // ── Column-picker only ──────────────────────────────────────────────
    { field: 'email', header: 'Email', sortable: true, width: 220, visibility: 'picker' },
    { field: 'type', header: 'Type', sortable: true, width: 140, visibility: 'picker' },
  ],

  actions: {
    toolbar: {
      primary: {
        id: 'ADD_TRADE_PRE_CLEARANCE',
        label: 'Add Trade Pre-Clearance',
        icon: 'add_circle_outline',
        semanticId: 'addTradePreClearanceButton',
      },
    },
    row: [{ id: 'REMOVE_TRADE_PRE_CLEARANCE', label: 'Remove from list', variant: 'danger' }],
    bulk: [{ id: 'BULK_REMOVE_TRADE_PRE_CLEARANCE', label: 'Remove Selected', variant: 'danger' }],
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: { keyField: 'participantId' },
    columnPreferences: { persistenceKey: 'Trade pre-clearance', resizable: true, reorderable: true },
  },
};
